import { render, staticRenderFns } from "./BateriaInterativa.vue?vue&type=template&id=6f33472a&"
import script from "./BateriaInterativa.vue?vue&type=script&lang=js&"
export * from "./BateriaInterativa.vue?vue&type=script&lang=js&"
import style0 from "./BateriaInterativa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports